"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFuturesPriceData = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_quotation_lib_1 = require("trade_quotation_lib");
const useFuturesPriceData = (params) => {
    const { base, quote, isActive = true, throttle = 0 } = params;
    const [priceData, setPriceData] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        if (!isActive || !base || !quote) {
            return;
        }
        const tickerOb = (0, trade_quotation_lib_1.getGlobalQuotationSocketMgr)()
            .getTickerWebSocket()
            .getTickerObservableByPair("pionex.v2", base, quote)
            .pipe((0, operators_1.startWith)(undefined));
        const indexOb = (0, trade_quotation_lib_1.getGlobalQuotationSocketMgr)()
            .getFIndexWebSocket()
            .getFIndexObservableByPair("pionex.v2", base, quote)
            .pipe((0, operators_1.startWith)(undefined));
        const sub = (0, rxjs_1.combineLatest)([tickerOb, indexOb])
            .pipe((0, operators_1.throttleTime)(throttle))
            .subscribe({
            next: ([ticker, index]) => {
                setPriceData({ ticker: ticker, index: index });
            },
            error: (err) => { },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [base, isActive, quote, throttle]);
    return priceData;
};
exports.useFuturesPriceData = useFuturesPriceData;
